export default __webpack_public_path__ + "static/media/K2D-ExtraLightItalic.61ef11ff.ttf";